import React, {Component} from 'react';
import './pageCss/Pro.css';
import projectJson from '../data/projects.json';
import NikeCom from '../components/ProjectComponents/NikeCom';
import PokeCom from '../components/ProjectComponents/PokeCom';
import VimoCom from '../components/ProjectComponents/VimoCom';
import {Helmet} from "react-helmet";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class Pro extends Component {
    constructor() {
        super();
        //Set default message
        this.state = {
        projects: projectJson,
        currentProject: window.location.pathname,
        projectCom: [ <NikeCom />, <PokeCom />, <VimoCom /> ]
        }
      }
      render(){
    var Project = this.state.projects.find(product => product.id == this.state.currentProject.split("/").pop())

  return (
    <div class="project-view">
        <Helmet>
        <style>{`body { background-color: ${Project.bgColor};}`}</style>
        </Helmet>
        <h3 class="back"><Link to={"/Projects"}>Back</Link></h3>
        <div class="project-view-section-1">
            <div class="pws1-item pws1-logo">
                <img src={process.env.PUBLIC_URL + "/images/logos/" + Project.image } class="pws1-pro-logo" />
            </div>
            <div class="pws1-item">
                <p class="pws1-pro-des">{Project.type}</p>
                <h2 class="pws1-pro-tit">{Project.title}</h2>
                <p class="pws1-pro-descript">{Project.description}</p>
            </div>
        </div>

        <div>
            {this.state.projectCom[Project.id]}
        </div>
    </div>
  );
}
}

export default Pro;
